export function limitQuotes(quotes) {
  if (!Array.isArray(quotes)) return []
  // 为了支持轮播功能，返回所有股票，不再限制为3个
  // 如果确实需要限制，可以改为 quotes.slice(0, 10) 或其他合适的数量
  return quotes
}

export function shouldStick(top, ratio) {
  return ratio === 0 && top <= 0
}
